import { updateCommisionCompany } from "api/Finances";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useEditCommission = () => {
    const queryClient = useQueryClient();
    return useMutation(updateCommisionCompany, {
        onSuccess: () => {
            toast.success("Added sucesfully");
            queryClient.invalidateQueries('commissions');
        },
        onError: () => {
            toast.error("Something went wrong! Please try again later.");
        },
    })
}